/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Members_Default_TextInputs */

const en_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const de_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const es_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const fr_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const it_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const pt_br2_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const pl_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const hu_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

const ro_admin_dashboard_empty_state_members_default_text = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Default_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

/**
* | output |
* | --- |
* | "+1" |
*
* @param {Admin_Dashboard_Empty_State_Members_Default_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_members_default_text = /** @type {((inputs?: Admin_Dashboard_Empty_State_Members_Default_TextInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Members_Default_TextInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_members_default_text(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_members_default_text(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_members_default_text(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_members_default_text(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_members_default_text(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_members_default_text(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_members_default_text(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_members_default_text(inputs)
	return ro_admin_dashboard_empty_state_members_default_text(inputs)
});
export { admin_dashboard_empty_state_members_default_text as "admin.dashboard.empty_state.members.default_text" }